import script from "./AdministratorProjectFormStep5.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep5.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep5.vue?vue&type=style&index=0&id=237dd930&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237dd930"]])

export default __exports__